import { render, staticRenderFns } from "./EditFolder.vue?vue&type=template&id=51e48136&scoped=true&"
import script from "./EditFolder.vue?vue&type=script&lang=js&"
export * from "./EditFolder.vue?vue&type=script&lang=js&"
import style0 from "./EditFolder.vue?vue&type=style&index=0&id=51e48136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e48136",
  null
  
)

export default component.exports